export default __webpack_public_path__ + "static/media/dot_permissionless.cbf8757d.svg";